import { useMemo } from 'react';

import type { Capability } from '@rtkwlf/capability';
import { useQuery } from '@tanstack/react-query';

import { capabilitiesQuery } from '../queries/capabilities';

/** @experimental For application using `@platform` only. */
export const useHasCapabilities = (
  organizationId: string,
  capabilities: Capability['id'][],
) => {
  const { data, isLoading } = useQuery(capabilitiesQuery(organizationId));

  return useMemo(() => {
    if (!data || isLoading) return null;
    return data.every((capability) => capabilities.includes(capability.id));
  }, [data, isLoading, capabilities]);
};
